import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";

import { PollyIcon, PollyIconName } from "../../../_shared/components/PollyIcon";

export const SettingLabel: React.FC<{
  icon: PollyIconName;
  content: React.ReactNode;
  compressed?: boolean;
}> = ({ icon, content, compressed }) => {
  return (
    <Flex gap="gap.small" vAlign="center" className={compressed ? "" : "settings-first-column"}>
      <PollyIcon icon={icon} />
      <Text content={content} />
    </Flex>
  );
};
